/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./loading.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "../spinner/spinner.component.ngfactory";
import * as i3 from "../spinner/spinner.component";
import * as i4 from "./loading.component";
var styles_UILoadingComponent = [i0.styles];
var RenderType_UILoadingComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_UILoadingComponent, data: {} });
export { RenderType_UILoadingComponent as RenderType_UILoadingComponent };
export function View_UILoadingComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "ui-spinner", [], null, null, null, i2.View_UISpinnerComponent_0, i2.RenderType_UISpinnerComponent)), i1.ɵdid(1, 49152, null, 0, i3.UISpinnerComponent, [], null, null)], null, null); }
export function View_UILoadingComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "ui-loading", [], null, null, null, View_UILoadingComponent_0, RenderType_UILoadingComponent)), i1.ɵdid(1, 49152, null, 0, i4.UILoadingComponent, [], null, null)], null, null); }
var UILoadingComponentNgFactory = i1.ɵccf("ui-loading", i4.UILoadingComponent, View_UILoadingComponent_Host_0, {}, {}, []);
export { UILoadingComponentNgFactory as UILoadingComponentNgFactory };
